import * as React from "react";
import type { SVGProps } from "react";
const SvgUkFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path fill="#fff" d="M3.141 5.141h13.717v9.717H3.141z" />
    <path
      stroke="#767676"
      strokeWidth={0.283}
      d="M3.141 5.141h13.717v9.717H3.141z"
    />
    <path
      fill="#DE2C2C"
      d="M8.245 8.365 3.575 5H3v.346l4.199 3.019zM11.737 11.635l4.7 3.365h.56v-.346l-4.2-3.019zM7.199 11.635 3 14.654V15h.56l4.7-3.365zM16.422 5l-4.67 3.365h1.046l4.199-3.019V5z"
    />
    <path
      fill="#DE2C2C"
      d="M10.986 5H9.01v3.946H3v2.108h6.011V15h1.975v-3.946h6.01V8.946h-6.01z"
    />
    <path
      fill="#03337C"
      d="M8.466 15v-2.767L4.636 15zM3 6.117v2.248h3.138zM11.53 5v2.752L15.347 5zM16.997 13.9v-2.265h-3.138zM16.997 8.365V6.1l-3.138 2.264zM8.466 5h-3.83l3.83 2.752zM3 11.635v2.248l3.138-2.248zM11.53 15h3.816l-3.815-2.767z"
    />
  </svg>
);
export default SvgUkFlag;
